import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import { FETCH_SEGMENTS_FAILURE, FETCH_SEGMENTS_REQUEST, FETCH_SEGMENTS_SUCCESS } from "../actions/segmentsActions";

  const initialState = {
    response: [],
    loading: true,
    error: null,
  };
  
  const segmentsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SEGMENTS_REQUEST:
        return { ...state, loading: true , payload: action.payload};
      case FETCH_SEGMENTS_SUCCESS:
        return { ...state, loading: false, response: action.payload };
      case FETCH_SEGMENTS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
        return { ...state, loading: false, response: [] };
      default:
        return state;
    }
  };
  
  export default segmentsReducer;
  